import ApiService from "@services/api.service";
import { Notify } from "quasar";

export const antenneSecteur = {
  state: {
    secteur: null,
  },
  mutations: {
    setSecteur(state, secteur){
      state.secteur = secteur;
    },
  },
  actions:{
    async fetchSecteurName(context, secteur){
      try{
        console.log(secteur)
       const response = await ApiService.getRequest(`antenne_secteur/${secteur}`);
       context.commit("setSecteur", response.data)
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters:{
    getSecteur(state){
      return state.secteur;
    }
  }
}
